var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceanalysisbackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1260,
    height: 495,
    viewBox: "0 0 1260 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_523_3631",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1260,
    height: 495
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 495,
    rx: 22,
    fill: "#F7F5FB"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_523_3631)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_523_3631",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -14,
    width: 1260,
    height: 509
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.02831C0 -4.12195 9.84974 -13.9717 22 -13.9717H1238C1250.15 -13.9717 1260 -4.12194 1260 8.02832V472.526C1260 484.676 1250.15 494.526 1238 494.526H22C9.84977 494.526 0 484.676 0 472.526V8.02831Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_523_3631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.71 -345.863C1213.36 -334.535 1147.58 -285.195 1151.28 -178.459C1155.9 -45.0395 1256.8 38.4528 1282.02 164.321C1300.64 257.22 1298 489.898 1184.49 587.656",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.28 -318.328C1167.93 -307 1102.15 -257.66 1105.85 -150.924C1110.47 -17.5045 1211.37 65.9877 1236.59 191.855C1255.21 284.755 1252.57 517.433 1139.06 615.19",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.16 -291.956C1121.8 -280.627 1056.02 -231.287 1059.72 -124.552C1064.35 8.86826 1165.25 92.3605 1190.47 218.228C1209.09 311.128 1206.45 543.806 1092.94 641.563",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.39 -266.736C1075.04 -255.408 1009.26 -206.068 1012.96 -99.3323C1017.58 34.0875 1118.48 117.58 1143.7 243.447C1162.32 336.347 1159.68 569.025 1046.17 666.783",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.99 -242.722C1027.64 -231.394 961.86 -182.054 965.56 -75.3179C970.184 58.1019 1071.08 141.594 1096.31 267.462C1114.92 360.362 1112.28 593.04 998.772 690.797",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.96 -220C979.606 -208.672 913.827 -159.332 917.526 -52.5964C922.151 80.8233 1023.05 164.316 1048.27 290.183C1066.89 383.083 1064.25 615.761 950.738 713.518",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.277 -198.696C930.925 -187.368 865.145 -138.028 868.845 -31.292C873.469 102.128 974.367 185.62 999.591 311.488C1018.21 404.388 1015.57 637.066 902.057 734.823",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.933 -178.97C881.58 -167.642 815.801 -118.301 819.5 -11.5657C824.125 121.854 925.022 205.346 950.247 331.214C968.864 424.114 966.222 656.792 852.712 754.549",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.909 -161.028C831.557 -149.699 765.778 -100.359 769.477 6.37647C774.102 139.796 874.999 223.288 900.224 349.156C918.841 442.056 916.199 674.734 802.689 772.491",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.196 -145.129C780.844 -133.801 715.065 -84.4609 718.764 22.2749C723.389 155.695 824.286 239.187 849.511 365.055C868.128 457.954 865.486 690.632 751.976 788.39",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.796 -131.605C729.444 -120.277 663.665 -70.937 667.364 35.7988C671.989 169.219 772.886 252.711 798.111 378.579C816.728 471.478 814.086 704.156 700.576 801.914",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.739 -120.874C677.387 -109.546 611.607 -60.2055 615.307 46.5303C619.932 179.95 720.829 263.442 746.054 389.31C764.671 482.21 762.029 714.888 648.519 812.645",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.104 -113.465C624.752 -102.137 558.972 -52.7971 562.672 53.9387C567.296 187.358 668.194 270.851 693.418 396.718C712.036 489.618 709.394 722.296 595.884 820.054",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.058 -110.047C571.706 -98.719 505.926 -49.3789 509.626 57.3569C514.25 190.777 615.148 274.269 640.372 400.137C658.99 493.036 656.348 725.714 542.838 823.472",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.92 -111.438C518.568 -100.11 452.788 -50.7697 456.488 55.9661C461.113 189.386 562.01 272.878 587.235 398.746C605.852 491.646 603.21 724.324 489.7 822.081",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.248 -118.583C465.896 -107.255 400.117 -57.9145 403.816 48.8213C408.441 182.241 509.338 265.733 534.563 391.601C553.18 484.501 550.538 717.179 437.028 814.936",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.938 -132.444C414.586 -121.116 348.807 -71.7759 352.506 34.96C357.131 168.38 458.028 251.872 483.253 377.74C501.87 470.639 499.228 703.317 385.718 801.075",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.433 -157.492C357.081 -146.164 291.301 -96.8235 295 9.91235C299.625 143.332 400.523 226.824 425.747 352.692C444.364 445.592 441.722 678.27 328.213 776.027",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.163 -177.404C307.811 -166.076 242.032 -116.736 245.731 -10C250.356 123.42 351.253 206.912 376.478 332.78C395.095 425.68 392.453 658.358 278.943 756.115",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.414 -193.185C257.062 -181.857 191.282 -132.517 194.982 -25.7812C199.606 107.639 300.504 191.131 325.728 316.998C344.346 409.898 341.704 642.576 228.194 740.334",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.534 -204.739C205.181 -193.411 139.402 -144.071 143.101 -37.3352C147.726 96.0846 248.623 179.577 273.848 305.445C292.465 398.344 289.823 631.022 176.313 728.78",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.887 -212.067C152.535 -200.739 86.7551 -151.398 90.4547 -44.6626C95.0792 88.7572 195.977 172.249 221.201 298.117C239.819 391.017 237.177 623.695 123.667 721.452",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.827 -215.26C99.4748 -203.932 33.6951 -154.592 37.3947 -47.856C42.0192 85.5638 142.917 169.056 168.141 294.924C186.759 387.824 184.117 620.502 70.6069 718.259",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6768 -214.482C46.3246 -203.154 -19.455 -153.814 -15.7555 -47.0784C-11.131 86.3414 89.7666 169.834 114.991 295.701C133.609 388.601 130.966 621.279 17.4567 719.036",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7154 -209.944C-6.6369 -198.616 -72.4165 -149.275 -68.7169 -42.5395C-64.0925 90.8802 36.8051 174.372 62.0295 300.24C80.647 393.14 78.005 625.818 -35.5048 723.575",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.8227 -201.876C-59.175 -190.548 -124.955 -141.208 -121.255 -34.4722C-116.631 98.9476 -15.7329 182.44 9.49149 308.308C28.109 401.207 25.4669 633.885 -88.0429 731.643",
    stroke: "#C8C8C8",
    strokeOpacity: 0.1,
    strokeWidth: 2.30422
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceanalysisbackground);
export default __webpack_public_path__ + "static/media/performanceanalysisbackground.8ef9fcdcd0ac0a18ee161b17b47c8e05.svg";
export { ForwardRef as ReactComponent };